// Use high-quality icon-only logo to avoid showing text portion
import logo from './logo/logoHighQuality.png';
import { Link, useMatch, useResolvedPath } from 'react-router-dom'
import { useAuth } from "../src/AuthContext";
import defaultUser from './assets/default-user.png';

const NavBar = () => {
    const { currentUser, userProfile } = useAuth();

    return (
        <div id='navsticky'>
            <CustomLink to='/'>
                {/* Use an actual img element for the icon-only logo to ensure visibility */}
                <img src={logo} alt="Happy Math" className="nav-logo-img" />
            </CustomLink>

            <ul id='navul'>
                <CustomLink to='/'>Home</CustomLink>
                <CustomLink to='/classes'>Classes</CustomLink>
                <CustomLink to='/practice'>Practice</CustomLink>
                {/* <CustomLink to='/battle'>Battle</CustomLink> */}
                <CustomLink to='/contests'>Contests</CustomLink>
                {/* <CustomLink to='/careers'>Career</CustomLink> */}
                {/*<CustomLink to='/team'>Our Team</CustomLink>*/}
                <CustomLink to='/contact'>Contact</CustomLink>
                {currentUser ? 
                    <CustomLink to='/profile'>
                        {/* Coin Display */}
                        {userProfile && (
                            <span style={{ marginRight: '10px', display: 'inline-flex', alignItems: 'center', color: '#f1c40f', fontWeight: 'bold' }}>
                                <i className="bi bi-coin" style={{ fontSize: '20px', marginRight: '5px' }}></i>
                                <span id="navbar-coins">{userProfile.coins || 0}</span>
                            </span>
                        )}
                        
                        <img 
                            src={userProfile?.picUrl || defaultUser}
                            alt="Profile"
                            style={{ 
                                width: '32px', 
                                height: '32px', 
                                borderRadius: '50%', 
                                verticalAlign: 'middle',
                                border: '2px solid #fff'
                            }} 
                        />
                    </CustomLink>
                    : <CustomLink to='/login'>Login</CustomLink>
                }
            </ul>

            <button id='icon' className="icon" onClick={
                () => {
                    var x = document.getElementById("navul");
                    if (x.className === "") {
                        x.className = "expanded";
                        document.getElementById("icon").innerHTML = "<i class='bi bi-x'></i>"
                    } else {
                        x.className = "";
                        document.getElementById("icon").innerHTML = "<i class='bi bi-arrow-bar-left'></i>"
                    }
                }
            }>
                <i className='bi bi-arrow-bar-left'></i>
            </button>
        </div>
    )
}

function CustomLink({ to, children, ...props }) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })

    return (
        <li style={{ listStyle: 'none' }}>
            <Link to={to} {...props} className={isActive ? "navlink active" : "navlink"} onClick={
                () => {
                    document.getElementById("navul").className = "";
                    document.getElementById("icon").innerHTML = "<i class='bi bi-arrow-bar-left'></i>"
                }
            }>
                {children}
            </Link>
        </li>
    )
}

export default NavBar